import PIN from './pin';

export default {
  namespaced: true,
  modules: {
    PIN,
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/setting_provider/index.js